/*
 * RN Mobile Enhancements
 * - [M-1]  Sticky Add-to-Cart bar on PDP (mobile)
 * - [M-7]  Announcement-bar scroll-hide (down) / show (up)
 * - [M-10] Network map lazy-load via IntersectionObserver
 * - [M-20] Header logo center on mobile
 * - [M-21] Network glass-card override + text-align center
 */
(function () {
  'use strict';
  var isMobile = function () { return window.matchMedia('(max-width: 980px)').matches; };
  var isPDP = /\/products\//.test(window.location.pathname);

  function injectNetworkOverrides() {
    if (document.getElementById('rn-network-override-style')) return;
    var s = document.createElement('style');
    s.id = 'rn-network-override-style';
    s.textContent =
      'body section.rn-network .rn-network__head{text-align:center !important}' +
      'body section.rn-network .rn-network__title{max-width:900px !important;margin-left:auto !important;margin-right:auto !important;text-align:center !important;text-wrap:balance}' +
      'body section.rn-network .rn-network__lead{color:rgba(255,255,255,0.82) !important;text-align:center !important;max-width:680px !important;margin-left:auto !important;margin-right:auto !important}' +
      'body section.rn-network .rn-network__feature{' +
        'background:linear-gradient(180deg, rgba(255,255,255,0.055) 0%, rgba(255,255,255,0.02) 100%) !important;' +
        'border:1px solid rgba(255,255,255,0.12) !important;' +
        'border-radius:14px !important;' +
        'backdrop-filter:blur(8px) !important;' +
        '-webkit-backdrop-filter:blur(8px) !important;' +
        'color:#FFFFFF !important;' +
      '}' +
      'body section.rn-network .rn-network__feature:hover{background:rgba(79,176,229,0.10) !important;border-color:rgba(79,176,229,0.35) !important}' +
      'body section.rn-network .rn-network__feat-title{color:#FFFFFF !important}' +
      'body section.rn-network .rn-network__feat-desc{color:rgba(255,255,255,0.78) !important}' +
      'body section.rn-network .rn-network__num{color:#4FB0E5 !important}';
    document.body.appendChild(s);
  }

  function injectHeaderCSS() {
    var s = document.createElement('style');
    s.id = 'rn-mobile-header-css';
    s.textContent =
      '@media (max-width: 980px){' +
        '.rn-nav__inner{grid-template-columns:1fr auto 1fr !important;align-items:center !important}' +
        '.rn-nav__burger{justify-self:start !important;margin-left:0 !important}' +
        '.rn-nav__cart-mobile{justify-self:end !important;margin-right:0 !important}' +
        '.rn-brand,.rn-brand--logo{justify-self:center !important;display:flex !important;align-items:center !important;justify-content:center !important;text-align:center !important;margin:0 auto !important}' +
        '.rn-brand__img,.rn-brand img{display:block !important;margin:0 auto !important;max-height:42px !important;width:auto !important}' +
      '}';
    document.head.appendChild(s);
  }

  function setupAnnouncementHide() {
    var bar = document.querySelector('.announcement-bar, .rn-announce, [class*="announcement-bar"]');
    if (!bar) return;
    var lastScroll = 0; var ticking = false;
    bar.style.transition = 'transform .25s ease, opacity .2s ease';
    bar.style.willChange = 'transform';
    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      if (y > 80 && y > lastScroll + 4) { bar.style.transform = 'translateY(-100%)'; bar.style.opacity = '0'; }
      else if (y < lastScroll - 4 || y < 60) { bar.style.transform = 'translateY(0)'; bar.style.opacity = '1'; }
      lastScroll = y; ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { requestAnimationFrame(onScroll); ticking = true; } }, { passive: true });
  }

  function setupStickyCart() {
    if (!isPDP) return;
    var form = document.querySelector('form[action*="/cart/add"]');
    if (!form) return;
    var origBtn = form.querySelector('button[type="submit"], [name="add"], [data-add-to-cart]');
    if (!origBtn) return;
    function getPrice() { var p = document.querySelector('.rn-pdp__price, [data-product-price], .price__regular .price-item--regular, .rn-product__price, .product__price, .price__container .price-item'); return p ? p.textContent.trim().replace(/\s+/g, ' ') : ''; }
    var bar = document.createElement('div');
    bar.id = 'rn-sticky-cart';
    bar.innerHTML = '<div class="rn-sticky-cart__inner"><div class="rn-sticky-cart__price" data-rn-sticky-price>' + getPrice() + '</div><button type="button" class="rn-sticky-cart__btn" data-rn-sticky-add>In den Warenkorb</button></div>';
    document.body.appendChild(bar);
    var style = document.createElement('style');
    style.textContent = '#rn-sticky-cart{position:fixed;left:0;right:0;bottom:0;z-index:9985;background:#fff;border-top:1px solid #E8E0CE;padding:10px 16px;padding-bottom:calc(10px + env(safe-area-inset-bottom,0px));box-shadow:0 -6px 22px rgba(15,37,64,.12);transform:translateY(100%);transition:transform .3s ease;display:none;font-family:var(--font-body-family,system-ui)}@media (max-width:980px){#rn-sticky-cart{display:block}}#rn-sticky-cart.is-visible{transform:translateY(0)}.rn-sticky-cart__inner{max-width:640px;margin:0 auto;display:flex;align-items:center;gap:12px}.rn-sticky-cart__price{flex:0 0 auto;font-weight:700;font-size:18px;color:#0E2A47;font-family:var(--font-heading-family,Oswald,system-ui);letter-spacing:.005em;white-space:nowrap}.rn-sticky-cart__btn{flex:1;min-height:52px;padding:14px 18px;background:#B84A0A;color:#fff;border:0;border-radius:8px;font-size:16px;font-weight:600;letter-spacing:.01em;cursor:pointer;transition:background .15s;font-family:inherit}.rn-sticky-cart__btn:hover,.rn-sticky-cart__btn:focus-visible{background:#9B3D06}body.rn-sticky-cart-on{padding-bottom:78px}';
    document.head.appendChild(style);
    var io = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (!isMobile()) { bar.classList.remove('is-visible'); document.body.classList.remove('rn-sticky-cart-on'); return; } if (!entry.isIntersecting) { bar.classList.add('is-visible'); document.body.classList.add('rn-sticky-cart-on'); } else { bar.classList.remove('is-visible'); document.body.classList.remove('rn-sticky-cart-on'); } }); }, { threshold: 0, rootMargin: '0px 0px -40px 0px' });
    io.observe(origBtn);
    bar.querySelector('[data-rn-sticky-add]').addEventListener('click', function () { try { origBtn.click(); } catch (e) {} });
    function syncPrice() { var p = getPrice(); var t = bar.querySelector('[data-rn-sticky-price]'); if (t && p) t.textContent = p; }
    document.addEventListener('variant:change', syncPrice);
    document.addEventListener('change', function (e) { if (e.target && (e.target.name === 'id' || e.target.closest('.product-form'))) { setTimeout(syncPrice, 60); } });
    var priceEl = document.querySelector('.rn-pdp__price, [data-product-price], .price__regular .price-item--regular, .rn-product__price, .product__price');
    if (priceEl && window.MutationObserver) { new MutationObserver(syncPrice).observe(priceEl, { childList: true, subtree: true, characterData: true }); }
  }

  function init() {
    try { injectNetworkOverrides(); } catch (e) {}
    try { injectHeaderCSS(); } catch (e) {}
    try { setupAnnouncementHide(); } catch (e) {}
    try { setupStickyCart(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
